import http from "../utils/http-common";

const getAllBranches = (data: any) => {
  return http.post("/registry/branches", data);
};
const getAllTags = (data: any) => {
  return http.post("/registry/tags", data);
};
const analyze = (data: any) => {
  return http.post("/registry/analyze", data);
};
const process = (data: any) => {
  return http.post("/registry/process_source", data);
};
const process_framework = (data: any) => {
  return http.post("/registry/process_framework", data);
};
const process_resource = (data: any) => {
  return http.post("/registry/process_emulator_resource", data);
};
const getRelease = (data: any) => {
  return http.get("/github_releases", { params: data });
};
const getReleaseAssets = (data: any) => {
  return http.get("/github_release_assets", { params: data });
};

const registryService = {
  getAllBranches,
  getAllTags,
  analyze,
  process,
  process_framework,
  process_resource,
  getRelease,
  getReleaseAssets,
};

export default registryService;
